import { MobileWalletButton } from '@/components/molecules/MobileWalletButton/MobileWalletButton'
import React from 'react'

const PHANTOM_DOWNLOAD_URL = 'https://phantom.com/download'
const SOLFLARE_DOWNLOAD_URL = 'https://solflare.com/download'

interface ButtonProps {
  onClick: (event: MouseEvent) => void;
  title: string;
}

interface WalletConfig {
  connectHandler: (walletName: string) => void;
  downloadUrl: string;
  isInstalled: boolean;
  name: 'Phantom' | 'Solflare';
  linkHandler?: (walletName: string) => void;
}

const getWalletButtonProps = (
  walletName: 'Phantom' | 'Solflare',
  isBrowser: boolean,
  isMobile: boolean,
  handleWalletClick: (walletName: string) => void,
  handleWalletLink?: (walletName: string) => void,
): ButtonProps | null => {
  const walletConfigs: WalletConfig[] = [
    {
      name: 'Phantom',
      isInstalled: !!window.phantom?.solana?.isPhantom,
      downloadUrl: PHANTOM_DOWNLOAD_URL,
      connectHandler: handleWalletClick,
      linkHandler: handleWalletLink,
    },
    {
      name: 'Solflare',
      isInstalled: !!window.solflare?.isSolflare,
      downloadUrl: SOLFLARE_DOWNLOAD_URL,
      connectHandler: handleWalletClick,
      linkHandler: handleWalletLink,
    },
  ]

  const wallet = walletConfigs.find((config) => config.name === walletName)
  if (!wallet) return null

  try {
    if (!wallet.isInstalled && isBrowser) {
      return {
        onClick: () => window.open(wallet.downloadUrl, '_blank'),
        title: `Download ${wallet.name}`,
      }
    }

    if (wallet.isInstalled && (isBrowser || isMobile)) {
      return {
        onClick: () => wallet.connectHandler(wallet.name),
        title: `Connect to ${wallet.name}`,
      }
    }

    if (!wallet.isInstalled && isMobile && wallet.linkHandler) {
      return {
        onClick: () => wallet.linkHandler(wallet.name),
        title: `Connect to ${wallet.name}`,
      }
    }

    return null
  } catch (error) {
    console.error(`Error determining ${wallet.name} button props:`, error)
    return null
  }
}

// Render wallet buttons
export function WalletButtons({ isBrowser, isMobile, handleWalletClick, handleWalletLink }: {
  handleWalletClick: (walletName: string) => void;
  isBrowser: boolean;
  isMobile: boolean;
  handleWalletLink?: (walletName: string) => void;
}) {
  const wallets: ('Phantom' | 'Solflare')[] = ['Phantom', 'Solflare']

  return (
    <>
      {wallets.map((walletName) => {
        const buttonProps = getWalletButtonProps(
          walletName,
          isBrowser,
          isMobile,
          handleWalletClick,
          handleWalletLink,
        )

        return buttonProps ? (
          // @ts-ignore
          <MobileWalletButton
            key={walletName}
            icon={walletName}
            {...buttonProps}
          />
        ) : null
      })}
    </>
  )
}
